// https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript

export function validateEmail(email: string) {
	const regex = new RegExp(
		/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	)
	return regex.test(email)
}

export function validateUrl(webUrl: string) {
	try {
		const url = new URL(webUrl)

		const isProtocolValid = ['http:', 'https:'].includes(url.protocol)

		const hostnameParts = url.hostname.split('.')
		const isTldExist = hostnameParts.filter((part) => part.length > 0).length > 1

		const tld = hostnameParts[hostnameParts.length - 1]
		const isTldNaN = isNaN(parseInt(tld))

		const isTldTwoMoreChars = tld.length >= 2

		const isTldValid = !tld.includes('{')

		return isProtocolValid && isTldExist && isTldNaN && isTldTwoMoreChars && isTldValid
	} catch (_e) {
		return false
	}
}

export function validateUrlOrIpAddress(url: string) {
	const ipV4V6Regex =
		/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?((([0-9]{1,3}\.){3}[0-9]{1,3})|(\[?[0-9a-fA-F:]{3,39}\]?))(:[0-9]{1,5})?(\/.*)?$/

	return ipV4V6Regex.test(url) || validateUrl(url)
}

export function isValidLocalhostUrl(url: string) {
	try {
		const parsedUrl = new URL(url)
		const hostname = parsedUrl.hostname

		const localhostRegex = /^localhost$/

		return localhostRegex.test(hostname)
	} catch (e) {
		return false
	}
}

export function validateRedirectLandingPageUrl(url: string) {
	return (validateUrlOrIpAddress(url) || isValidLocalhostUrl(url)) && url.includes('{cid}')
}

export function validateIp(ip: string): boolean {
	return validateIpV4(ip) || validateIpV6(ip)
}

export function validateIpV4(ip: string): boolean {
	const regex = new RegExp(
		/^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/,
	)

	return regex.test(ip)
}

export function validateIpV6(ip: string): boolean {
	const regex = new RegExp(
		/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/,
	)

	return regex.test(ip)
}
